import { defineNuxtPlugin } from '#app'
import { useSnackbarStore } from '~/stores/snackbar'

declare module '#app' {
  interface NuxtApp {
    $snackbar: {
      showMessage: (payload: SnackbarPayload) => void
    }
  }
}

export default defineNuxtPlugin(() => {
  return {
    provide: {
      snackbar: useSnackbarStore(),
    },
  }
})
